import type { PortfolioImage, PortfolioItem } from "@/features/portfolio-items/types";

export type PortfolioSort = "featured" | "newest" | "oldest" | "custom";

export interface PortfolioCategoryOption {
  label: string;
  value: string;
}

export function getPortfolioImage(item: PortfolioItem): PortfolioImage | null {
  return item.images.find((image) => image.isPrimary) ?? item.images[0] ?? null;
}

export function getPortfolioTags(item: PortfolioItem) {
  return [item.category?.name, item.featured ? "Featured" : null].filter(Boolean) as string[];
}

export function getShortDescription(description: string | null) {
  if (!description) return "Project details are being prepared.";
  if (description.length <= 150) return description;
  return `${description.slice(0, 147).trim()}...`;
}

export function filterPortfolioItems(items: PortfolioItem[], category: string, search: string) {
  const normalizedSearch = search.trim().toLowerCase();

  return items.filter((item) => {
    const matchesCategory = category === "all" || item.category?.slug === category;
    if (!matchesCategory) return false;

    if (!normalizedSearch) return true;

    const searchable = [
      item.title,
      item.description,
      item.clientName,
      item.category?.name,
      item.category?.slug,
      ...getPortfolioTags(item),
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return searchable.includes(normalizedSearch);
  });
}

export function sortPortfolioItems(items: PortfolioItem[], sort: PortfolioSort) {
  return [...items].sort((a, b) => {
    if (sort === "featured") {
      if (a.featured !== b.featured) return a.featured ? -1 : 1;
      return a.sortOrder - b.sortOrder || b.createdAt.localeCompare(a.createdAt);
    }

    if (sort === "newest") return b.createdAt.localeCompare(a.createdAt);
    if (sort === "oldest") return a.createdAt.localeCompare(b.createdAt);

    return a.sortOrder - b.sortOrder || a.title.localeCompare(b.title);
  });
}
